import { render, staticRenderFns } from "./handmadePrescriptionDetails.vue?vue&type=template&id=0f603354&scoped=true"
import script from "./handmadePrescriptionDetails.vue?vue&type=script&lang=js"
export * from "./handmadePrescriptionDetails.vue?vue&type=script&lang=js"
import style0 from "./handmadePrescriptionDetails.vue?vue&type=style&index=0&id=0f603354&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f603354",
  null
  
)

export default component.exports